
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getApplicationStatus = async () => {
  return await get<ApiResponse<any[]>>("/applicationStatus").then((res)=>{
      return res
    })
};

 